<template>
  <div class="collect" v-loading='pageLoading'>
    <div class="flex items">
      <div v-for="(v, i) in listData" :key="v.id" class="hd-item" @click="openInfo(v)">
        <div class="tag">{{typeOpt(v).name}}</div>
        <div class="cancel" @click.stop="cancel(v, i)">取消参与</div>
        <div class="box">
          <el-image
            style="width: 100%; height: 150px"
            :src="isHead(v.imgpath1)"
            fit="cover"
          >
            <template #placeholder>
              <el-image
                style="width: 100%; height: 150px"
                :src="isHead()"
                fit="cover"
              >
              </el-image>
            </template>
            <template #error>
              <el-image
                style="width: 100%; height: 150px"
                :src="isHead('err')"
                fit="cover"
              >
              </el-image>
            </template>
          </el-image>
          <div class="info">
            <el-tooltip
              class="item"
              effect="dark"
              :content="v.title"
              placement="bottom-start"
            >
              <div class="title ellipsis">
                {{ v.title }}
              </div>
            </el-tooltip>
            <div class="click">活动时间：{{formatTime(v.servstarttime, "YYYY-MM-DD HH:mm")}} 至 {{formatTime(v.servendtime, "MM-DD HH:mm")}}</div>
            
          </div>
        </div>
      </div>
    </div>
   
    <div class="tip-box flex">
      <el-divider v-show="loading && !isOver"><el-button :loading="true">加载中</el-button></el-divider>
      <el-divider v-show="!loading && !isOver"><el-button size="small" @click="getList()">加载更多</el-button></el-divider>
      <el-divider v-show="!loading && isOver">已全部加载</el-divider>
    </div>
  </div>
</template>

<script>
import { reactive, watch, toRefs } from "vue";
import { api } from "@/api";
import { useStore } from "vuex";
import { isHead, formatTime } from "@/tools"
import { openInfo, typeOpt } from "@/tools/jump"
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
  setup() {
    let store = useStore();
    let initData = reactive({
      userInfo: "",
      isOver: false,
      loading: true,

      listData: "",
      pageLoading: false
    });
    watch(() => store.state.userInfo, (value) => {
      initData.userInfo = value;
      getList()
    }, {immediate: true});
    
    // 获取列表
    function getList() {
      
      let data = {
        userid: initData.userInfo.id,
        relevant: 0
      }
      initData.loading = true
      api("get", "myTicket", data).then(res => {
        initData.loading = false
        if(res.code == 1200) {
          if(res.data) {
            initData.listData = res.data
            initData.isOver = true
          } else {
            initData.isOver = true
          }
        } else {
          initData.isOver = true
        }
      })
    }
    // 取消活动
    function cancel(row) {
      let data = {
        uid: initData.userInfo.id,
        aid: row.articleid,
       
      }
      
      ElMessageBox.confirm('此操作将取消该参与活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        initData.pageLoading = true
        api("get", "deleteServfunApply", data)
          .then(res => {
            initData.pageLoading = false
            if(res.code === 1200) {
              ElMessage('已取消');
              initData.isOver = false
              initData.loading = true
              getList()
            } else {
              ElMessage.error('操作失败, 请重新尝试');
            }
          })
          .catch(err => {
            initData.pageLoading = false
            ElMessage.error('操作失败, 请重新尝试');
          })
      }).catch(() => { });
      
    }
    return {
      ...toRefs(initData),
      isHead,
      formatTime,
      openInfo,
      typeOpt,
      getList,
      cancel
    };
  },
};
</script>

<style lang="less" scoped>
.items {
  display: flex;
  flex-flow: wrap;
}
.hd-item {
  width: 321px;
  // height: 290px;
  padding: 12px;
  box-sizing: border-box;
  transition: all 0.5s;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: #f7f8fa;
    box-shadow: 0 4px 10px 0 #bbb;
    top: -1px;
    .box {
      background-color: #fff;
      position: relative;

      .info {
        .title {
          color: #07c160;
        }
      }
    }
  }
  .tag {
    line-height: 1;
    padding: 5px 10px 4px;
    color: #fff;
    border-radius: 3px;
    font-size: 14px;
    background-color: #00bcd4;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .04), 0 0 6px rgba(0, 0, 0, .1);
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 10;
  }
  .cancel {
    line-height: 1;
    padding: 5px 10px 4px;
    color: #fff;
    border-radius: 3px;
    font-size: 14px;
    background-color: #999;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .04), 0 0 6px rgba(0, 0, 0, .1);
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 10;
  }
  .box {
    width: 100%;
    height: 100%;
    background-color: #f7f8fa;
    font-size: 0;
    position: relative;

    .info {
      font-size: 14px;
      color: #a8a8a8;
      padding: 7px 12px 14px;
      box-sizing: border-box;

      .title {
        width: 80%;
        line-height: 40px;
        font-size: 16px;
        color: #333;
      }

      .click {
        // padding-top: 4px;
        font-size: 13px;
        .tag {
          display: inline-block;
          line-height: 1;
          padding: 2px 3px 1px;
          background-color: #ff9800;
          font-size: 12px;
          margin-right: 5px;
          color: #fff;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>